import {useSelector} from 'react-redux';

import {getUserProperties} from '../../../../../../modules/selectors/userSelectors';
import {
  MY_PROGRESS_ITEM,
  MY_PROGRESS_WORD_WALL_ITEM,
  REPORTS_MENU_CLASSROOM_DATA_ITEM,
  REPORTS_MENU_POWER_WORDS_ITEM,
  REPORTS_MENU_USAGE_REPORT_ITEM,
  REPORTS_MENU_STANDARDS_REPORT_ITEM,
} from '../constants';

export const useGetReportsMenuSectionProps = () => {
  const {canAdminViewUsageReport, canAdminViewStandardsReport, isStaff, isStudent} = useSelector((state) =>
    getUserProperties(state)
  );

  const reportsMenuSectionTitle = isStudent ? 'My progress' : 'Reports';

  const reportsMenuSectionItems = [];

  if (isStudent) {
    reportsMenuSectionItems.push(MY_PROGRESS_ITEM);
    reportsMenuSectionItems.push(MY_PROGRESS_WORD_WALL_ITEM);

    return {
      reportsMenuSectionTitle,
      reportsMenuSectionItems,
    };
  }

  // Classroom data
  reportsMenuSectionItems.push(REPORTS_MENU_CLASSROOM_DATA_ITEM);

  // Power words
  reportsMenuSectionItems.push(REPORTS_MENU_POWER_WORDS_ITEM);

  // Usage report
  if (canAdminViewUsageReport || isStaff) {
    reportsMenuSectionItems.push(REPORTS_MENU_USAGE_REPORT_ITEM);
  }

  // Admin standards report
  if (canAdminViewStandardsReport || isStaff) {
    reportsMenuSectionItems.push(REPORTS_MENU_STANDARDS_REPORT_ITEM);
  }

  return {
    reportsMenuSectionTitle,
    reportsMenuSectionItems,
  };
};
